<template>
  <div>
    <v-container>
      <v-row>
        <v-col xs="12" sm="6" md="4" :class="classPadding">
          <department-lookup v-model="department" :class-padding="classPadding" label="Department"></department-lookup>
        </v-col>
        <v-col xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field label="Department Head" v-model="depHead" :class="classPadding"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
         <v-col xs="12" sm="6" md="4" :class="classPadding">
          <v-select :items="monthItems" v-model="month" :class="classPadding" label="Month" item-text="text" item-value="value"></v-select>
        </v-col>
         <v-col xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field label="Year" type="number" v-model="year" :class="classPadding"></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Report Date"
            v-model="reportDate"
          ></custom-datepicker>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <span>Report Format:</span>
          <v-radio-group row v-model="reportFormat" :class="classPadding">
            <v-radio label="English" value="EN"></v-radio>
            <v-radio label="Tagalog" value="FIL"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
          <v-textarea v-model="message"  rows="15" label="Remarks">
          </v-textarea>
        </v-col>
      </v-row>
      
      <p :class="'ma-0 pa-0'">
          Legend: 
        </p><br/>
        <p :class="'ma-0 pa-0'">{NUMBER_OFFENSE_PER_MONTH} - The number of offense per month.</p><br/>
        <p :class="'ma-0 pa-0'">{MONTH_YEAR} - The month and year of tardiness. </p><br/>
        <p :class="'ma-0 pa-0'">{DAYS_LATE} - The days late per month..</p><br/>
        <p :class="'ma-0 pa-0'">{NO_OFFENSE_AS_OF_MONTH} - The number of offense accumulated as of selected month.</p>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
          <v-btn outlined text @click.stop="save" :loading="isSaving">Save</v-btn>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
          <span>Noted By</span>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <employee-lookup v-model="notedBy1" :class-padding="classPadding" :off-remarks="true"></employee-lookup>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <employee-lookup v-model="notedBy2" :class-padding="classPadding" :off-remarks="true"></employee-lookup>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <employee-lookup v-model="notedBy3" :class-padding="classPadding" :off-remarks="true"></employee-lookup>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
          <span>Approved By</span>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <employee-lookup v-model="approvedBy1" :class-padding="classPadding" :off-remarks="true"></employee-lookup>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <employee-lookup v-model="approvedBy2" :class-padding="classPadding" :off-remarks="true"></employee-lookup>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <employee-lookup v-model="approvedBy3" :class-padding="classPadding" :off-remarks="true"></employee-lookup>
        </v-col>
      </v-row>

      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const DepartmentLookup = () => import("../../setup/employment-info/organizational-level/department/Lookup")
const EmployeeLookup = () => import("../../maintenance/employee-masterfile/personal-info/Lookup")
const API_ENDPOINT = "/api/reports"
import isEmpty from "lodash/isEmpty"
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    department: {},
    monthItems: [
      { text: "January", value: "1"}, 
      { text: "February", value: "2"}, 
      { text: "March", value: "3"}, 
      { text: "April", value: "4"}, 
      { text: "May", value: "5"}, 
      { text: "June", value: "6"},
      { text: "July", value: "7"}, 
      { text: "August", value: "8"}, 
      { text: "September", value: "9"}, 
      { text: "October", value: "10"}, 
      { text: "November", value: "11"}, 
      { text: "December", value: "12"}
    ],
    month: "January",
    depHead: "",
    year:null,
    reportDate: null,
    reportFormat: "EN",
    message: ``,
    isSaving: false,
    reportConfig: {},
    emp: {},
    notedBy1: {},
    notedBy2: {},
    notedBy3: {},
    approvedBy1: {},
    approvedBy2: {},
    approvedBy3: {},
    loading: false
  }),
  components: {
    CustomDatepicker,
    DepartmentLookup,
    EmployeeLookup
  },
  methods: {
    save() {
      this.isSaving = true;
      this.$axios.post(`/api/other/report-format`, {
        Format: this.reportFormat,
        Message: this.message
      })
      .then(({ data }) => {
        this.$toast.success(data.message);
      })
      .catch(({ response }) => {
        this.$toast.error(response.data.message);
      })
      .finally(() => {
        this.isSaving = false
      })
    },
    getReportFormat(){
      this.$axios.get(`/api/other/report-format`)
      .then(({ data }) => {
        if(!isEmpty(data)){
          this.reportConfig = data;
          this.assignMessage();
        }
      })
      .catch(({ response }) => {
        this.$toast.error(response.data.message);
      })
    },
    assignMessage(){
      if(this.reportFormat == "EN") {
        this.message = this.reportConfig.englishFormat;
      }else {
        this.message = this.reportConfig.tagalogFormat;
      }
    },
    exportReport() {
      this.loading = true;
      this.$axios.post(`${API_ENDPOINT}/list-of-emp-tardiness`, {
        DepCode: this.department.code,
        Month: this.month,
        Year: this.year,
        ReportFormat: this.reportFormat  == "EN" ? "English" : "Tagalog",
        ApprovedByCode: this.approvedBy1.code,
        ApprovedByCode2: this.approvedBy2.code,
        ApprovedByCode3: this.approvedBy3.code,
        NotedByCode: this.notedBy1.code,
        NotedByCode2: this.notedBy2.code,
        NotedByCode3: this.notedBy3.code,
        Remarks: this.message,
        ReportDate: this.reportDate
      })
      .then(({ data }) => {
        var subPath = process.env.VUE_APP_PATH;
        window.open(
          `${subPath.slice(0, -1)}/report-viewer?reportCode=${
            data.reportCode
          }&dbName=${data.dbName}&key=${data.key}&companyKey=${
            data.companyKey
          }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
            data.logoAlign
          }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
        );
      })
      .catch(({ response }) => {
        this.$toast.error(response.data.message);
      })
      .finally(() => {
        this.loading = false
      })
    }
  },
  created() {
    this.getReportFormat();

  },
  watch: {
    reportFormat(){
     this.assignMessage();
    }
  }
}
</script>